export const LISTINGS_QUERY = 'listings';
export const SLUG_QUERY = 'slug';
